import { getAccHostname, getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { NOTIFICATION_STATUSES } from '@adsk/alloy-react-notification';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import PermissionSelect from '@adsk/alloy-react-permission-select';
import { USER_ACCOUNT_OFFERING_TYPES, TRIAL_STATUS } from '@common/constants';

export const getSelectValueLabel = (selectValue, selectOptions) => {
  if (!selectValue || selectOptions?.length === 0) return '';

  const value = Array.isArray(selectValue) ? selectValue : [selectValue];

  return value
    .map(
      (val) =>
        selectOptions.find(
          (option) => option.value === (typeof e === 'string' ? val : val.value)
        ).label
    )
    .join(', ');
};

export const getPillValue = (level) => {
  const pillValue = {};
  for (let i = 0; i < 4; i += 1) {
    if (i < level) {
      pillValue[i] = PermissionSelect.PILL_TYPES.FULL;
    } else {
      pillValue[i] = PermissionSelect.PILL_TYPES.EMPTY;
    }
  }
  return pillValue;
};

export const getToolsUrls = (projectId) => ({
  buildFiles: `${getAccHostname()}/build/docs/projects/${projectId}`,
  sheets: `${getAccHostname()}/build/sheets/projects/${projectId}/settings?moduleId=permit`,
  submittals: `${getAccHostname()}/build/submittals/projects/${projectId}/settings/permissions`,
  rfis: `${getAccHostname()}/build/rfis/projects/${projectId}/settings/permissions`,
  issues: `${getAccHostname()}/build/issues/projects/${projectId}/permissions`,
  docsFiles: `${getAccHostname()}/docs/files/projects/${projectId}`,
  cost: `${getAccHostname()}/cost/settings/projects/${projectId}/services/permission`,
  progressTracking: `${getAccHostname()}/build/progress-tracking/projects/${projectId}/settings/permissions`,
});

export const getOfferingsURL = (accountId, memberId) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/users/${memberId}/offerings`;

export const getTrialsURLForAA = (accountId, memberId) =>
  `${getAdminApiUrl()}/internal/v1/accounts/${accountId}/users/${memberId}/subscriptions`;

export const getTrialsURLForPA = (projectId, memberId) =>
  `${getAdminApiUrl()}/internal/v1/projects/${projectId}/users/${memberId}/subscriptions`;

const hasSubscription = (userSubscriptions, product) =>
  userSubscriptions.some((subscription) =>
    subscription.products.some((p) => p.type === product.type)
  );

export const getProductsSubscriptions = (
  memberOfferingsData,
  memberTrialsData,
  member,
  products,
  T,
  productIds
) => {
  const userSubscriptions = memberOfferingsData.results.filter(
    (offering) =>
      offering.type !== USER_ACCOUNT_OFFERING_TYPES.NONE &&
      offering.type !== USER_ACCOUNT_OFFERING_TYPES.TRIAL
  );
  /* eslint-disable no-param-reassign */
  return products
    .filter(
      (p) =>
        productIds.includes(p.type) &&
        p.type !== PRODUCT_IDS.PROJECT_ADMINISTRATION &&
        p.type !== PRODUCT_IDS.ACCOUNT_ADMINISTRATION
    )
    .reduce((result, product) => {
      if (!hasSubscription(userSubscriptions, product)) {
        const productTrials = memberTrialsData.results.filter((trial) =>
          trial.products.some((p) => p.key === product.type)
        );
        const activeTrial = productTrials.find(
          (trial) =>
            trial.status === TRIAL_STATUS.ACTIVE && trial.daysRemaining > 0
        );
        if (activeTrial) {
          result[product.type] = {
            status: NOTIFICATION_STATUSES.WARNING,
            text: T.translate('TRIAL_COUNTDOWN', {
              memberName: member.firstName,
              trialDays: activeTrial.daysRemaining,
            }),
          };
        } else if (
          productTrials.some((trial) => trial.status === TRIAL_STATUS.EXPIRED)
        ) {
          result[product.type] = {
            status: NOTIFICATION_STATUSES.ERROR,
            text: T.translate('TRIAL_EXPIRED', {
              memberName: member.firstName,
              productName: product.name,
            }),
          };
        } else {
          result[product.type] = {
            status: NOTIFICATION_STATUSES.INFO,
            text: T.translate('NO_SUBSCRIPTION', {
              memberName: member.firstName,
            }),
          };
        }
      }
      /* eslint-enable no-param-reassign */

      return result;
    }, {});
};
